import { Attributes, List, LookupBase, Misc, Model, ModelBase, Rules, Validation } from '@singularsystems/neo-core';
import InvestorInvestmentClientApproval from '../Approvals/InvestorInvestmentClientApproval';

export class InvestorInvestmentNoticeRequest extends ModelBase {
    static typeName = "InvestorInvestmentNoticeRequest";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorInvestmentNoticeRequestId: number = 0;

    @Rules.Required()
    public investorInvestmentId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public noticeDate: Date | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = null;

    @Attributes.Float()
    public amount: number = 0;

    @Attributes.Nullable()
    public shareTransactionId: number | null = null;

    public isCancellation: boolean = false;

    public createdBy: number = 0;

    @Attributes.Date()
    public createdOn: Date = new Date();

    @Attributes.ChildObject(Model.UserEvent, true)
    public cancelled: Model.UserEvent = Model.UserEvent.None();

    @Attributes.ChildObject(Model.UserEvent, true)
    public actioned: Model.UserEvent = Model.UserEvent.None();

    @Attributes.ChildObject(Model.UserEvent, true)
    public authorised: Model.UserEvent = Model.UserEvent.None();

    public clientApprovals = new List(InvestorInvestmentClientApproval);

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public readonly lookup: LookupFields = new LookupFields();

    // Client only properties / methods

    public get type() {
        if (this.isCancellation) {
            return "Cancellation";
        } else if (this.shareTransactionId) {
            return "Roll Notice";
        } else {
            return "New Notice";
        }
    }

    public get status() {
        if (this.cancelled.on) {
            return "Cancelled";
        } else if (this.authorised.on) {
            return "Complete";
        } else if (this.actioned.on) {
            return "Awaiting Authorisation";
        } else if (this.clientApprovals.length < this.lookup.requiredClientAuthorisations) {
            return "Awaiting Client Authorisation";
        } else {
            return "Pending";
        }
    }

    public get canAction() {
        return this.actioned.on === null
            && this.cancelled.on === null
            && this.clientApprovals.length >= this.lookup.requiredClientAuthorisations;
    }

    public get canAuthorise() {
        return this.actioned.on !== null && this.authorised.on === null;
    }

    protected static addBusinessRules(rules: Validation.Rules<InvestorInvestmentNoticeRequest>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investor investment notice request";
        } else {
            return "Investor Investment Notice Request";
        }
    }
}

export class LookupFields extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public createdBy: string = "";

    public actionedBy: string | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public shareTransactionDate: Date | null = null;

    @Attributes.Integer()
    public requiredClientAuthorisations: number = 0;

    // Client only properties / methods
}